/*
 * 时间戳转换成当地时间
 */
export function timestamp2localdate(timestamp: number, showTime?: boolean) {
    if(!timestamp || timestamp === null){
        return null;
    }
    const date = new Date(timestamp);
    if(showTime){
        return date.toLocaleString();
    }
    else{
        const date = new Date(timestamp);
        let year = date.getFullYear().toString();
        let month = (date.getMonth() + 1).toString(); // Month is zero-based, so we add 1
        let day = date.getDate().toString(); 
        return year + '-' + month + '-' + day;
    }

}


